import React from 'react';
import { Reveal } from './Reveal';
import { images } from '../data/site';
export function TestTank() {
  return <section aria-labelledby="tank-title" className="relative isolate w-full overflow-hidden bg-navy-950" data-id="element-345" data-mp="2dis41ilt6gm8">
      <img src={images.testTank} alt="Outboard engine running under load in Soundside Marine's hydraulic drive-in test tank, water churning" loading="lazy" className="absolute inset-0 -z-20 h-full w-full object-cover" data-id="element-346" data-mp="28liabqrdzisl" />
      <div className="absolute inset-0 -z-10 bg-navy-950/80" aria-hidden="true" data-id="element-347" data-mp="2wal1bp7wunzr" />
      <div className="gutter section-y" data-id="element-348" data-mp="2wcnpe3pi671u">
        <Reveal data-id="element-349" data-mp="2rijfbbkxxiwj">
          <p className="text-sm font-semibold text-water-300" data-id="element-350" data-mp="2ri9xiba1ui1x">Why the test tank matters</p>
          <h2 id="tank-title" className="display mt-4 max-w-[18ch] text-[clamp(3rem,7vw,8.5rem)] font-extrabold text-white" data-id="element-351" data-mp="2nh7y9ug4u5zy">
            The only hydraulic drive-in test tank in the area.
          </h2>
          <div className="mt-8 max-w-[52ch] space-y-1 text-xl text-white/85 md:text-2xl" data-id="element-352" data-mp="3f8ds5t59f7gs">
            <p data-id="element-353" data-mp="36a6ednke1ecv">We run your engine under real load, year-round, before you ever leave the dock.</p>
            <p className="font-semibold text-white" data-id="element-354" data-mp="3b76kfyh8mh3z">No guessing, no “try it and see.”</p>
          </div>
        </Reveal>
      </div>
    </section>;
}